import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { PageContext, RedirectorPaynowConfig } from 'src/app/service/redirector.service'
import { PaynowLayoutComponent } from 'src/app/buy-page/paynow/paynow-layout/paynow-layout.component'

@Component({
  selector: 'app-paynow-vertrieb',
  templateUrl: './paynow-vertrieb.component.html',
  styleUrl: './paynow-vertrieb.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PaynowLayoutComponent,
  ],
})
export class PaynowVertriebComponent {
  @Input() context!: PageContext<RedirectorPaynowConfig>

  protected usps = [{
    icon: 'verified',
    head: $localize`Einzigartigkeit`,
    body: $localize`Eine schöne Domain ist einmalig und hebt Sie von Ihren Wettbewerbern ab. Sie reduziert auch die Verwechslungsgefahr für Ihre Marke!`,
  }, {
    icon: 'highlight',
    head: $localize`Mehr Sichtbarkeit`,
    body: $localize`Mit einer guten Domain erzeugen Sie sofort mehr Sichtbarkeit, erhalten neue Besucher und steigern den Umsatz. Auch können Sie mehrere Domains auch auf Ihr Projekt weiterleiten.`,
  }, {
    icon: 'psychology_alt',
    head: $localize`Bessere Merkbarkeit`,
    body: $localize`Eine schöne Domain kann man sich leicht merken. Man behält die Adresse im Hinterkopf. Besucher werden so zu wiederkehrenden Kunden.`,
  }, {
    icon: 'sentiment_satisfied',
    head: $localize`Mehr Kundenvertrauen`,
    body: $localize`Mit einer professionellen Domain schaffen Sie viel Vertrauen bei Kunden, Lieferanten und Stakeholdern. Die Domain strahlt Seriosität für Ihr Business aus.`,
  }, {
    icon: 'health_and_safety',
    head: $localize`Schutz vor der Konkurrenz`,
    body: $localize`Sichern Sie sich eine professionelle Internetadresse in Ihrer Branche! Damit schaffen Sie natürliche Markteintrittsbarrieren und erzeugen einen dauerhaften Wettbewerbsvorteil.`,
  }, {
    icon: 'euro_symbol',
    head: $localize`Niedrigere Marketingkosten`,
    body: $localize`Geringere Marketingkosten durch einen besseren Quality-Score bei Online-Werbekampagnen und wiederkehrende Besucher durch einen natürlichen Branding-Effekt.`,
  }]
}
